import { Injectable, signal } from '@angular/core';
import { ToastButton } from '@ionic/angular';

type ToastPosition = 'top' | 'middle' | 'bottom';

export interface ToastRequest {
    /** Main message to display inside the toast */
    message: string;
    duration?: number;
    color?: string;
    position?: ToastPosition;
    icon?: string;
    cssClass?: string | string[];
    buttons?: ToastButton[];
    translucent?: boolean;
    keyboardClose?: boolean;
}

interface ToastState extends ToastRequest {
    isOpen: boolean;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
    private readonly defaultState: ToastState = {
        isOpen: false,
        message: '',
        duration: 2500,
        position: 'bottom',
        translucent: false,
        keyboardClose: false
    };

    private readonly _state = signal<ToastState>({ ...this.defaultState });

    readonly state = this._state.asReadonly();

    show(request: ToastRequest | string): void {
        const normalized: ToastRequest = typeof request === 'string'
            ? { message: request }
            : request;

        this._state.set({
            ...this.defaultState,
            ...normalized,
            isOpen: true
        });
    }

    dismiss(): void {
        this._state.update(state => ({ ...state, isOpen: false }));
    }
}
